import { React } from 'react';
import { Chart as ChartJS, Tooltip, Legend, LinearScale, PointElement, LineElement, LogarithmicScale } from 'chart.js';
import { Scatter } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';
import '../theme/chartTheme.css';
import Star from '../images/star_black_24dp.svg';
import { useSelector } from 'react-redux';

ChartJS.register(LinearScale, PointElement, LineElement, LogarithmicScale, Tooltip, Legend, annotationPlugin);

const PerformanceScatterplot = (props) => {
  const relationalType = useSelector((state) => state.auth.relationalType)
  function toggleLabel(ctx, event) {
    const chart = ctx.chart;
    const annotationOpts = chart.options.plugins.annotation.annotations[0];
    annotationOpts.label.display = !annotationOpts.label.display;
    chart.update();
  }
  const formattedChartTotals = props.chartTotals.map((obj) => {
    const newObj = {};

    newObj.x = obj.quality_score;
    if (obj.underwriting_inaccuracy === 0) {
      newObj.y = 0.8;
    } else {
      newObj.y = obj.underwriting_inaccuracy;
    }

    newObj.size = obj.total_agents;

    return newObj;
  });

  const chartPoint = new Image();
  chartPoint.src = Star;

  const options = {
    elements: {
      point: {
        backgroundColor: function (ctx) {
          var index = ctx.dataIndex;
          var data = ctx.dataset.data[index];
          if (data.size >= 100) {
            return 'rgba(17, 23, 68, 0.7)';
          } else if (data.size >= 50) {
            return 'rgba(31, 42, 122, 0.7)';
          } else if (data.size >= 30) {
            return 'rgba(47, 64, 187, 0.7)';
          } else if (data.size >= 10) {
            return 'rgba(102, 116, 217, 0.7)';
          } else {
            return 'rgba(170, 178, 234, 0.7)';
          }
        },
        radius: 8,
        // function(ctx){
        //   var index = ctx.dataIndex;
        //   var data = ctx.dataset.data[index];
        //   var size = ctx.chart.width;
        //   var base = Math.abs(data.size) / 500;
        //   var value =  Math.round((size /5) * base);
        //   return value;    }
        //     pointStyle: "circle",
      },
    },
    layout: {
      autoPadding: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      annotation: {
        // annotation plugin options
        annotations: [
          // {
          //   xMin: 3.4,
          //   xMax: 3.4,
          //   type: "line",
          //   borderWidth: 5,
          //   borderColor: "rgb(65,105,225,0.5)",
          //   drawTime: "beforeDatasetsDraw",
          //   label: {
          //     display: false,
          //     borderWidth: 0,
          //     color: "black",
          //     backgroundColor: "rgb(65,105,225,0.5)",
          //     content: (ctx) => ["Threshold line"],
          //     textAlign: "center",
          //     position: {
          //       x: 'center',
          //       y: 'start'
          //     }
          //   },
          //   enter(ctx, event) {
          //     toggleLabel(ctx, event);
          //   },
          //   leave(ctx, event) {
          //     toggleLabel(ctx, event);
          //   },
          // },
          {
            xMin: 8.2,
            xMax: 10,
            yMin: 0,
            yMax: 5,
            backgroundColor: 'rgba(216, 247, 244, 0.7)',
            type: 'box',
            borderDashOffset: 0,
            borderWidth: 0,
            drawTime: 'beforeDatasetsDraw',
            label: {
              display: false,
              borderWidth: 0,
              color: '#023020',
              backgroundColor: 'rgb(65,105,225,0.5)',
              content: (ctx) => ['High Performance Zone'],
              textAlign: 'center',
              position: {
                x: 'center',
                y: 'start',
              },
            },
            enter(ctx, event) {
              toggleLabel(ctx, event);
            },
            leave(ctx, event) {
              toggleLabel(ctx, event);
            },
          },
          // {
          //   xMin: 0,
          //   xMax: 3.4,
          //   yMin: 0,
          //   yMax: 100,
          //   backgroundColor: "rgba(249, 224, 224, 0.5)",
          //   type: "box",
          //   borderDashOffset: 0,
          //   borderWidth: 0,
          //   drawTime: "beforeDatasetsDraw",
          // },
        ],
      },
      legend: {
        display: false,
        position: 'right',
      },
      tooltip: {
        callbacks: {
          label: function (ctx) {
            var index = ctx.dataIndex;
            var data = ctx.dataset.data[index];
            if (ctx.dataset.label === 'You') {
              return data.y === 0.8 ? `QS:${data.x} FUI:0` : `QS:${data.x} FUI:${data.y}`;
            }
            return `${data.size} agent(s)`;
          },
        },
      },
    },
    scales: {
      x: {
        min: 0,
        max: 10,
        position: 'top',
        title: {
          display: true,
          text: 'Quality Score',
          font: {
            family: 'Helvetica',
            size: 14,
          },
          size: 11,
        },
      },
      y: {
        beginAtZero: true,
        min: 0.8,
        max: 100,
        type: 'logarithmic',
        reverse: true,
        title: {
          display: true,
          text: 'Field Underwriting Inaccuracy Rate (FUI)',
          font: {
            family: 'Helvetica',
            size: 14,
          },
          size: 11,
        },
        ticks: {
          callback: (value, index) => (value === 0.8 ? '0%' : value % 10 === 0 ? `${value}%` : ''),
        },
      },
    },
  };

  let  data ={}
  if(relationalType === 87){
    data = {
      datasets: [
        {
          label: 'You',
          data: [{ x: props.qualityScore, y: props.uwInaccuracy === 0 ? 0.8 : props.uwInaccuracy, size: 1 }],
          pointStyle: chartPoint,
          borderWidth: 4,
          radius: 40,
          backgroundColor: 'rgba(254, 137, 29, 0.7)',
        },
        {
          label: 'Other Agents',
          data: formattedChartTotals,
        },
      ],
    };
  }else{
    data = {
      datasets: [
        {
          label: 'Agents',
          data: formattedChartTotals,
        },
      ],
    };
  }
  

  return (
    <div id="canvas-container">
      <Scatter options={options} data={data}></Scatter>
    </div>
  );
};

export default PerformanceScatterplot;
